import { TIER_LIMIT_KEYS, TierCatalogEntry } from "@/types/api/tiers";
import { monitoringCaptureError } from "@/plugins/monitoring";
import { signaloidApiClient } from "../signaloidClient";

const TIER_CATALOG_TRANSACTION = "Fetch tier catalog";

function reportLimitShapeMismatches(catalog: TierCatalogEntry[]): void {
	const servedPerTier = catalog.map((entry) => Object.keys(entry?.Limits ?? {}));

	const unknownKeys = [...new Set(servedPerTier.flat())].filter((key) => !TIER_LIMIT_KEYS.includes(key));
	if (unknownKeys.length > 0) {
		monitoringCaptureError(
			new Error(`Tier catalog served unknown limits: ${unknownKeys.join(", ")}`),
			TIER_CATALOG_TRANSACTION,
		);
	}

	const droppedKeys = TIER_LIMIT_KEYS.filter((key) => servedPerTier.some((servedKeys) => !servedKeys.includes(key)));
	if (droppedKeys.length > 0) {
		monitoringCaptureError(
			new Error(`Tier catalog stopped serving limits: ${droppedKeys.join(", ")}`),
			TIER_CATALOG_TRANSACTION,
		);
	}
}

export async function getTiers(): Promise<TierCatalogEntry[]> {
	const response = await signaloidApiClient.get<TierCatalogEntry[]>("/tiers");

	if (!Array.isArray(response.data)) {
		throw new Error("Tier catalog response was not a list of tiers");
	}

	reportLimitShapeMismatches(response.data);

	return response.data;
}
